import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import { createPortal } from 'react-dom'
import { layering, spacing } from '@mobi/component-library/Foundations'
import { Modal } from '../Modal'
import { Tray } from '../Tray'

type Props = {
  isModal: boolean
  isOpen: boolean
  headerTitle?: string
  children?: ReactNode
  dismissStatus?: 'allowed' | 'disallowed' | 'disabled'
  onDismiss?: () => void
}
export const ModalOrTray = ({
  isModal,
  children,
  isOpen,
  headerTitle,
  dismissStatus,
  onDismiss,
}: Props) => {
  const commonProps = {
    isOpen,
    dismissStatus: dismissStatus || 'disallowed',
    onDismiss: onDismiss || (() => null),
    headerTitle,
  }

  return isModal ? (
    <Modal
      {...commonProps}
      modalStyle={{ maxWidth: '40rem' }}
      headerStyle={{ height: '0', backgroundColor: 'transparent' }}
      zIndex={layering.modalOverlay}
    >
      <ModalContentStyled>{children}</ModalContentStyled>
    </Modal>
  ) : (
    createPortal(
      <Tray {...commonProps} trayStyle={{ maxWidth: '77.6rem' }}>
        {children}
      </Tray>,
      document.body
    )
  )
}

const ModalContentStyled = styled.div({
  padding: spacing.md,
})
